import { render, staticRenderFns } from "./ProjectTagsCard.vue?vue&type=template&id=400aae9e"
import script from "./ProjectTagsCard.vue?vue&type=script&lang=js"
export * from "./ProjectTagsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports